import React, { Component } from 'react';
import { EmptyList } from '../../../../../shared/empty-list/EmptyList';
import '../../../../../shared/table/AlertsTable.scss';
import './TeamsList.scss';
import TransparentButton from '../../../../../shared/button/transparent-button/TransparentButton';
import { redirectTo } from '../../../../../routing/redirectService';
import { AddButton } from '../../../../../shared/button/AddButton';
import { PermissionPipe } from '../../../../../shared/pipes/PermissionPipe';
import AddTeamModal from '../add-team/AddTeamModal';
import * as _ from 'lodash';
import { permissionsToDisplay } from '../../../../../shared/models/permissions';
import { extendWithModalSupport } from '../../../../../shared/modal-container/ModalContainer';
import { TableSearch } from '../../../../../shared/table-search/TableSearch';
import { PageActionsRow } from '../../../../../shared/headers/PageActionsRow';
import { PermissionCheckbox } from '../../../../../shared/permission-checkbox-list/PermissionCheckbox';
import { SpinLoader } from '../../../../../shared/spin-loader/SpinLoader';

const teams_headers = [
    { key: 'NAME', value: 'NAME', showArrowSort: true },
    { key: 'DESCRIPTION', value: 'DESCRIPTION', showArrowSort: true },
    ..._.map(permissionsToDisplay, permission => ({
        key: PermissionPipe(permission),
        value: PermissionPipe(permission),
        showArrowSort: false
    })),
    { key: null, value: '' } /* This is the actions column. */
];

export class TeamsList extends Component {
    constructor(props) {
        super(props);
        extendWithModalSupport(this);
    }

    hasPermission = (permission, teamPermissions) => {
        return !!teamPermissions.find(
            teamPermission => teamPermission === permission
        );
    };

    togglePermission = (team, permission) => {
        team.permissions.find(teamPermission => teamPermission === permission)
            ? _.isFunction(this.props.removePermission) &&
              this.props.removePermission(team.id, permission)
            : _.isFunction(this.props.addPermission) &&
              this.props.addPermission(team.id, permission);
    };

    navigateToDetails = teamId => {
        redirectTo(`teams/details/${teamId}`);
    };

    render() {
        const { teams, loaded } = this.props;

        return (
            <div className="container">
                <PageActionsRow>
                    <AddButton
                        key={'add-team'}
                        onClick={() => this.modalInstance.openModal()}
                        label={'Add Team'}
                    />
                </PageActionsRow>

                <div className={'teams-list table'}>
                    <table>
                        <tbody>
                            <tr className={'table-options'}>
                                <td colSpan={teams_headers.length}>
                                    <TableSearch
                                        placeholder={'Search for teams...'}
                                        onSearch={() => {
                                            /* todo: Add search teams*/
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr className="headers">
                                {teams_headers.map(header => (
                                    <th key={header.key}>{header.key}</th>
                                ))}
                            </tr>

                            {!loaded ? (
                                <tr>
                                    <td colSpan={teams_headers.length}>
                                        <SpinLoader />
                                    </td>
                                </tr>
                            ) : (
                                (teams &&
                                    teams.length &&
                                    teams.map(team => (
                                        <tr key={team.id} className="data">
                                            <td>{team.name}</td>
                                            <td
                                                className={'description-column'}
                                            >
                                                {team.description}
                                            </td>
                                            {_.map(
                                                permissionsToDisplay,
                                                permission => (
                                                    <td
                                                        key={permission}
                                                        className={
                                                            'align-center'
                                                        }
                                                    >
                                                        <PermissionCheckbox
                                                            checked={this.hasPermission(
                                                                permission,
                                                                team.permissions
                                                            )}
                                                            onChange={() =>
                                                                this.togglePermission(
                                                                    team,
                                                                    permission
                                                                )
                                                            }
                                                            value="secondary"
                                                            color="primary"
                                                        />
                                                    </td>
                                                )
                                            )}
                                            <td>
                                                <TransparentButton
                                                    onClick={() =>
                                                        this.navigateToDetails(
                                                            team.id
                                                        )
                                                    }
                                                >
                                                    Details
                                                </TransparentButton>
                                            </td>
                                        </tr>
                                    ))) || (
                                    <tr
                                        className="data"
                                        style={{ textAlign: 'center' }}
                                    >
                                        <td colSpan={teams_headers.length}>
                                            <EmptyList />
                                        </td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
                <AddTeamModal ref={this.modalRef} />
            </div>
        );
    }
}
